// extracted by mini-css-extract-plugin
export default {"FeeController":"L_dbUavn5lIwfLuqgdK1","address":"FgPZFLus1rkTR16NC3Sr","feeHeading":"T8Braohy5jAwunGm5NvE","warning":"EcDLK7locZAKXztYEoym","button":"k2ix2gJYBhwBVDzP83_Q"};